import React from 'react'
import Main from '../components/TechBoard/Main'

const TechBoard = () => {
  return (
    <div>
        <Main/>
    </div>
  )
}

export default TechBoard